import { toastConstants } from '../constants'

const displayMessage = (message, type) => dispatch => {
	dispatch(startTimer())
	dispatch({
		type,
		message
	})
}

/**
 * Displays a success message
 * @param {object} message message to be displayed
 */
const success = ({ message }) => displayMessage(message, toastConstants.SUCCESS)

/**
 * Displays a warning message
 * @param {string} message message to be displayed
 */
const warning = ({ message }) => displayMessage(message, toastConstants.WARNING)

/**
 * Displays a danger message
 * @param {string} message message to be displayed
 */
const danger = ({ message }) => displayMessage(message, toastConstants.DANGER)

/**
 * Starts the close process on the toast setting the closed attr to true.
 * Do not exclude messsage because the component needs to make a trasition first
 */
const startClosing = () => ({
	type: toastConstants.START_CLOSING
})

/**
 * Finishes the close process on the toast reseting the message.
 */
const close = () => ({
	type: toastConstants.CLOSE
})

let currentTimeout = null
let closeTimeout = null

const startTimer = () => dispatch => {
	if (currentTimeout !== null || closeTimeout !== null) {
		clearTimeout(currentTimeout)
		clearTimeout(closeTimeout)
	}

	currentTimeout = setTimeout(() => {
		currentTimeout = null
		dispatch(startClosing())
	}, 7000)
}

export const toastActions = { success, warning, danger, startClosing, close }
